import { BarcodeSearch } from '@client/catalog/api/BarcodeSearch';
import {
  fetchBarcodeSearch,
  fetchBarcodeSearchFulfilled,
  fetchBarcodeSearchRejected,
} from '@client/catalog/redux/barcodeSearch/redux';
import { requestApiSaga } from '@client/common/redux/api/sagas';
import { reportError } from '@client/common/redux/errors/actions';
import { parseError } from '@client/common/utils/api/error';
import { AxiosResponse } from 'axios';
import { all, call, CallEffect, put, PutEffect, takeLatest } from 'redux-saga/effects';
import { BarcodeSearchType } from 'b2b-common/core/catalog/Catalog.types';

function* fetchBarcodeSearchSaga(
  action: ReturnType<typeof fetchBarcodeSearch>,
): Generator<CallEffect | PutEffect, void, AxiosResponse<BarcodeSearchType>> {
  const barcode = action.payload;

  try {
    const { data } = yield call(requestApiSaga, BarcodeSearch.fetch(barcode));
    yield put(fetchBarcodeSearchFulfilled({ barcode, data }));
  } catch (error) {
    yield put(fetchBarcodeSearchRejected({ barcode, error: parseError(error) }));
    yield put(reportError({ message: action.type, error, additionalData: { barcode } }));
  }
}

export function* barcodeSearchSaga(): Generator<any, any, any> {
  yield all([
    takeLatest(fetchBarcodeSearch.type, fetchBarcodeSearchSaga),
  ]);
}
